export default __webpack_public_path__ + "static/media/Generic_Icon.ebc2b69a.svg";